<script>
  import { onMount } from 'svelte'
  import CodeMirror from 'codemirror/src/codemirror.js'
  let classes = ''
  export let editor = null
  export let options = {}
  export let defaultValue = null
  export let value
  export let onChange = () => {}
  export { classes as class }
  let element
  onMount(() => {
    createEditor(options)
    if (defaultValue) {
      value = defaultValue
    }
  })
  $: if(element) { createEditor(options) }
  function createEditor(options) {
    if (!window) return
    if (!element) return
    if (editor) element.innerHTML = ''
    editor = CodeMirror(element, {...options, value})
    editor.on('change', () => {
      value = editor.getValue()
      onChange(editor.getValue())
    })
  }
  $: if (editor) {
    const pos = editor.getCursor()
    editor.setValue(value)
    editor.setCursor(pos)
  }
  $: if (editor) {
    Object.entries(options).forEach(([key, value]) => {
      editor.setOption(key, value)
    })
  }
</script>

<div bind:this={element} class={classes}/>